export default {
  id: '__R',
  code: 'CN',
  text: {
    'You do not have permission': '您无此操作权限',
  }
}



// WEBPACK FOOTER //
// ./src/containers/__R/locale.js